<template>
  <div>
    <v-card
      :height="dimension + 'vh'"
      class="rounded-0 container"
      :outlined="!borderOff"
      tile
      :style="'background-color: ' + color"
      :class="scrollY ? 'containerScroll' : ''"
      elevation="0"
    >
      <slot></slot>
    </v-card>
    <v-card
      v-if="footer"
      class="rounded-0 container"
      :outlined="!borderOff"
      tile
      :style="'background-color: ' + footerColor"
      elevation="0"
      :height="footerSize + 'vh'"
      neme="footer"
    >
      <slot class="text-center" name="footer"></slot>
    </v-card>
  </div>
</template>

<script>
const props = {
  alignIcon: {
    default: "#007AB9",
    type: String,
  },
  color: {
    default: "#F7F9F9",
    type: String,
  },
  dimension: {
    default: "100",
    type: String,
  },
  className: {
    default: "",
    type: String,
  },
  changeIcon: {
    default: 700,
    type: Number,
  },
  scrollY: {
    default: false,
    type: Boolean,
  },
  borderOff: {
    default: false,
    type: Boolean,
  },
  footer: {
    default: false,
    type: Boolean,
  },
  footerColor: {
    default: "#F7F9F9",
    type: String,
  },
  footerSize: {
    default: "8",
    type: String,
  },
};

export default {
  methods: {
    execute() {
      if (this.onClick) {
        this.onClick();
      }
    },
  },
  props: props,
};
</script>

<style scoped>
.containerScroll {
  overflow-y: scroll;
}
.alignText {
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
